<template>
  <span class="status-pill" :class="toneClass">{{ label }}</span>
</template>

<script>
const MAP = {
  pending: { label: 'Pending', class: 'bg-amber-100 text-amber-800' },
  published: { label: 'Published', class: 'bg-emerald-100 text-emerald-800' },
  expired: { label: 'Expired', class: 'bg-slate-200 text-slate-600' },
  rejected: { label: 'Rejected', class: 'bg-rose-100 text-rose-700' },
  submitted: { label: 'Pending', class: 'bg-amber-100 text-amber-800' },
  viewed: { label: 'Viewed', class: 'bg-sky-100 text-sky-800' },
  contacted: { label: 'Accepted', class: 'bg-emerald-100 text-emerald-800' },
}

export default {
  name: 'StatusBadge',
  props: {
    status: { type: String, required: true },
  },
  computed: {
    meta() {
      return MAP[this.status] || { label: this.status, class: 'bg-slate-100 text-slate-700' }
    },
    label() {
      return this.meta.label
    },
    toneClass() {
      return this.meta.class
    },
  },
}
</script>
